import { ApplicantGroupType } from '@exam-center/graphql';
import { Flex, Box, Text, FormSearchSelection, FormTextField } from '@shared/components';

import { getApplicantLabelAndValue } from './utils';

const applicantGroupTypes: ApplicantGroupType[] = [
  ApplicantGroupType.Bank,
  ApplicantGroupType.InsuranceCompany,
  ApplicantGroupType.SecuritiesCompany,
  ApplicantGroupType.ProjectFree,
  ApplicantGroupType.ProjectCharge,
  ApplicantGroupType.Student,
  ApplicantGroupType.Others,
];

const options = applicantGroupTypes
  .map((type) => getApplicantLabelAndValue(type))
  .filter((value) => value !== undefined);

export default function OptionalInformationFormField() {
  return (
    <Flex sx={{ gap: (theme) => theme.spacing(6) }}>
      <Box sx={{ width: 240 }}>
        <Text variant='body1Semibold'>ข้อมูลกลุ่มผู้สมัคร</Text>
      </Box>
      <Flex sx={{ gap: (theme) => theme.spacing(2) }}>
        <Flex
          sx={{
            gap: (theme) => theme.spacing(4),
            minWidth: '400px',
            flexDirection: 'column',
          }}
        >
          <FormSearchSelection
            name='groupType'
            options={options}
            label='ประเภทกลุ่มผู้สมัคร'
            placeholder='เลือกประเภทกลุ่มผู้สมัคร'
          />
          <FormTextField
            name='groupCode'
            label='รหัสกลุ่มผู้สมัคร'
            placeholder='กรอกรหัสกลุ่มผู้สมัคร'
          />
        </Flex>
      </Flex>
    </Flex>
  );
}
